import * as React from "react";
import { REFINED } from "../../risikoanalyseStep/tokens";
import { alleDokumente } from "../../windowManager/browserFenster/fensterRegister";

interface ErreichbarkeitClockButtonProps {
  fieldLabel: string;
  value?: string;
  onChange: (nextValue: string) => void;
}

export const ErreichbarkeitClockButton: React.FC<ErreichbarkeitClockButtonProps> = ({
  fieldLabel,
  value = "",
  onChange,
}) => {
  const [open, setOpen] = React.useState(false);
  const [draft, setDraft] = React.useState(value);
  const popoverRef = React.useRef<HTMLDivElement>(null);
  const btnRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    setDraft(value || "");
  }, [value, open]);

  // Click outside to close
  React.useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target as Node) &&
        btnRef.current &&
        !btnRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    alleDokumente.addEventListener("mousedown", handleClickOutside);
    return () => alleDokumente.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const hasValue = Boolean(value && value.trim());

  const handleSave = () => {
    onChange(draft.trim());
    setOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen(!open)}
        title={hasValue ? `Erreichbarkeit (${fieldLabel}): ${value}` : `Erreichbarkeit für ${fieldLabel} hinterlegen`}
        aria-label={`Erreichbarkeit für ${fieldLabel}`}
        style={{
          background: "none",
          border: "none",
          padding: "0",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: hasValue ? "#7d2069" : REFINED.ink3,
          transition: "color 0.15s ease",
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth={hasValue ? 2 : 1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="8" cy="8" r="6.2" />
          <polyline points="8 4.2 8 8 10.5 9.5" />
        </svg>
      </button>

      {open && (
        <div
          ref={popoverRef}
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            right: 0,
            zIndex: 10000,
            width: "260px",
            backgroundColor: REFINED.white,
            border: `1px solid ${REFINED.line}`,
            borderRadius: "10px",
            boxShadow: REFINED.cardShadow,
            padding: "12px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            fontFamily: REFINED.fontUI,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ fontSize: "0.78rem", fontWeight: 700, color: REFINED.ink }}>
            Erreichbarkeit: {fieldLabel}
          </div>
          <input
            autoFocus
            type="text"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="z. B. Mo–Fr 9–12 Uhr"
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "6px 8px",
              fontSize: "0.82rem",
              borderRadius: "6px",
              border: `1px solid ${REFINED.line}`,
              outline: "none",
              fontFamily: REFINED.fontUI,
              color: REFINED.ink,
            }}
          />
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "6px", marginTop: "2px" }}>
            <button
              type="button"
              onClick={() => setOpen(false)}
              style={{
                background: "none",
                border: `1px solid ${REFINED.line}`,
                borderRadius: "6px",
                padding: "4px 8px",
                fontSize: "0.76rem",
                cursor: "pointer",
                color: REFINED.ink,
                fontFamily: REFINED.fontUI,
              }}
            >
              Abbrechen
            </button>
            <button
              type="button"
              onClick={handleSave}
              style={{
                backgroundColor: REFINED.aub,
                border: `1px solid ${REFINED.aub}`,
                borderRadius: "6px",
                padding: "4px 10px",
                fontSize: "0.76rem",
                cursor: "pointer",
                color: REFINED.white,
                fontWeight: 600,
                fontFamily: REFINED.fontUI,
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ErreichbarkeitClockButton;
